<template>
  <nav :style="activeSystem==''?'display:none':''">
    <a id="wt-toggler" class="btn bt-lg toggler" @click="changeLayout">
      <i class="fa fa-lg fa-bars"></i>
    </a>
  </nav>
</template>
<script>
export default {
  name: "wt-header-toggler",
  components: {},
  props: {},
  computed: {
    typeLayout() {
      return this.$store.state.layout.typeLayout;
    },
    activeSystem() {
      return this.$store.state.activeSystem;
    }
  },
  data: function() {
    return {
      layout: null
    };
  },
  methods: {
    changeLayout() {
      this.layout = this.typeLayout;

      if (this.layout < 4) {
        this.layout++;
      } else if (this.layout == 4) {
        this.layout = 2;
      }

      this.$store.commit("setTypeLayout", this.layout);
    }
  }
};
</script>
